import { TokenStorage } from '../../signin/data/TokenStorage'

export default (tokenStorage: TokenStorage) => {
    return {
        Authorization: `Bearer ${tokenStorage.getToken()}`,
        Accept: 'application/json',
        'Content-Type': 'application/json',
    }
}
